import { render, staticRenderFns } from "./ConfigHelpdesk.vue?vue&type=template&id=37cb38c3&"
import script from "./ConfigHelpdesk.vue?vue&type=script&lang=js&"
export * from "./ConfigHelpdesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports